module.exports = __webpack_public_path__ + "static/media/my-property.ba1aefd2.svg";